<div class="h-100 d-flex justify-content-around align-items-center gap-0_5">
  <i class="cp icon-tests-settings" (click)="onClick('copy')" tooltip="Test case details"></i>
  <i
    class="cp icon-bug"
    [class.disabled]="!phoneReportState.isAllowed && !phoneReportState.canOpenReport"
    (click)="onCreateReportClick()"
    [tooltip]="phoneReportState.tooltip || (phoneReportState.canOpenReport ? 'Show number report' : 'Phone number report')"></i>
  <i class="cp icon-more" (click)="onClick('more')" [ngClass]="{ applied: currentRow.commentId }" tooltip="More actions"></i>
</div>
